import './memberSelector.css';

import * as React from 'react';
import Member from 'src/entities/Member';

import PlusGreenLight from '../../res/img/plus_green_light.svg';

interface IProps {
  callback: (memberId: number) => void;
  members: Member[];
}

interface IState {
  keyword: string;
  isExpanded: boolean;
}

class MemberSelectorComponent extends React.Component<IProps, IState> {
  keywordInput: HTMLInputElement;

  constructor(props: any) {
    super(props);
    this.state = {
      keyword: '',
      isExpanded: false
    };

    this.onChangeKeyword = this.onChangeKeyword.bind(this);
    this.onBlurKeyword = this.onBlurKeyword.bind(this);
    this.expand = this.expand.bind(this);
  }

  render() {
    const members = this.props.members.filter(
      member =>
        (member.nameLast.includes(this.state.keyword) ||
          member.nameFirst.includes(this.state.keyword)) &&
        !member.archived
    );

    return (
      <div className="MemberSelector">
        <div className="Image" onClick={this.expand}>
          <img src={PlusGreenLight} />
        </div>
        <input
          ref={input => {
            this.keywordInput = input as HTMLInputElement;
          }}
          className={
            this.state.isExpanded ? 'InputText' : 'InputText InputHidden'
          }
          value={this.state.keyword}
          onChange={this.onChangeKeyword}
          onBlur={this.onBlurKeyword}
        />
        {this.state.isExpanded ? (
          <div className="AddMemberCandidates">
            {members.map(member => (
              <div
                key={member.id}
                className="AddMemberCandidate"
                onMouseUp={this.selectMember.bind(this, member.id)}
                onTouchEnd={this.selectMember.bind(this, member.id)}
              >
                {member.nameLast + member.nameFirst}
              </div>
            ))}
          </div>
        ) : null}
      </div>
    );
  }

  selectMember(memberId: number) {
    this.setState({
      keyword: '',
      isExpanded: false
    });
    this.props.callback(memberId);
  }

  onChangeKeyword(e: any) {
    this.setState({
      keyword: e.target.value
    });
  }

  onBlurKeyword(e: any) {
    if (this.state.isExpanded) {
      setTimeout(() => {
        this.setState({
          keyword: '',
          isExpanded: false
        });
      }, 300);
    }
  }

  expand(e: any) {
    if (!this.state.isExpanded) {
      this.setState({
        isExpanded: true
      });
      setTimeout(() => {
        this.keywordInput.focus();
      }, 10);
    }
  }
}

export default MemberSelectorComponent;



// WEBPACK FOOTER //
// ./src/components/Memo/memberSelector.tsx